var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Participant-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01a_Create-Account-Terms",
    transform: "translate(-1132.000000, -239.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(1132.000000, 239.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.486107545,13.1071983 L5.57801071,7.98470491 L0.486107545,2.89280175 C-0.162035848,2.24465836 -0.162035848,1.16485713 0.486107545,0.486107545 C1.16490518,-0.162035848 2.24528297,-0.162035848 2.89280175,0.486107545 L7.98470491,5.57801071 L13.1071983,0.486107545 C13.7553416,-0.162035848 14.8351429,-0.162035848 15.5138925,0.486107545 C16.1620358,1.16490518 16.1620358,2.24528297 15.5138925,2.89280175 L10.3913991,7.98470491 L15.5138925,13.1071983 C16.1620358,13.7553416 16.1620358,14.8351429 15.5138925,15.5138925 C14.8350948,16.1620358 13.754717,16.1620358 13.1071983,15.5138925 L7.98470491,10.3913991 L2.89280175,15.5138925 C2.24465836,16.1620358 1.16485713,16.1620358 0.486107545,15.5138925 C-0.162035848,14.8350948 -0.162035848,13.754717 0.486107545,13.1071983 L0.486107545,13.1071983 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.17d960e823070948be5db036b42469c8.svg";
export { ForwardRef as ReactComponent };